import { Box, Stack, Text, useToken } from "@chakra-ui/react";
import React from "react";
import { FiLayout, FiPlusSquare, FiType } from "react-icons/fi";
import { LayoutItemList } from "./LayoutItemList";
import { TextTabContent } from "./TextTabContent";
import { WidgetList } from "./WidgetList";
const fontColor = "gray.600";
export const LayoutLateralMenu = React.memo(({ selectedTab, setSelectedTab, isLocked, screenWidth, screenHeight, widgets, layoutItems, }) => {
    var _a, _b;
    const tabs = [
        {
            name: "Zones",
            icon: FiLayout,
            content: React.createElement(LayoutItemList, null),
        },
        {
            name: "Widgets",
            icon: FiPlusSquare,
            content: (React.createElement(WidgetList, { layoutItems: layoutItems, widgets: widgets, isLocked: isLocked, screenHeight: screenHeight, screenWidth: screenWidth })),
        },
        {
            name: "Texte",
            icon: FiType,
            content: React.createElement(TextTabContent, null),
        },
        // {
        //   name: "Pages",
        //   icon: FiGrid,
        //   content: <PagesList />,
        // },
    ];
    const [fontHexColor] = useToken("colors", [fontColor]);
    const SelectedTabContent = (_b = (_a = tabs.find((tab) => tab.name === selectedTab)) === null || _a === void 0 ? void 0 : _a.content) !== null && _b !== void 0 ? _b : React.createElement(React.Fragment, null);
    return (React.createElement(Stack, { direction: "row", spacing: 0, m: "-24px", borderTopLeftRadius: 12, borderBottomLeftRadius: 12, overflow: "hidden", height: "100%", width: "calc(100% + 24px)" },
        React.createElement(Stack, { flex: 1 }, tabs.map((tab, index) => {
            const TabIcon = tab.icon;
            const isTabSelected = selectedTab === tab.name;
            return (React.createElement(Stack, { justifyContent: "center", alignItems: "center", height: "76px", width: "76px", p: 2, cursor: "pointer", gap: 0, backgroundColor: isTabSelected ? "orange.400" : undefined, sx: {
                    aspectRatio: "1/1",
                }, onClick: () => {
                    setSelectedTab(tab.name);
                }, key: `studio-lateral-menu-${index}`, "data-testid": `lateral-menu-${tab.name.toLowerCase()}-icon-test-id` },
                React.createElement(TabIcon, { size: "30px", strokeWidth: 1.5, color: isTabSelected ? "white" : fontHexColor }),
                React.createElement(Text, { fontSize: "sm", color: isTabSelected ? "white" : "gray.800", mt: "0 !important" }, tab.name)));
        })),
        React.createElement(Box, { p: 4, width: "calc(100% - 76px)" }, SelectedTabContent)));
}, (prevProps, nextProps) => {
    if (prevProps.selectedTab !== nextProps.selectedTab)
        return false;
    if (prevProps.layoutItems.length !== nextProps.layoutItems.length)
        return false;
    if (prevProps.selectedLayoutItemId !== nextProps.selectedLayoutItemId)
        return false;
    if (prevProps.isLocked !== nextProps.isLocked)
        return false;
    return true;
});
